import React, {useState, useEffect} from 'react'
import {ONBOARDING_IMPORTANCE_CRITICAL, ONBOARDING_IMPORTANCE_REQUIRED} from '../../constants/ModelConstants'
import {
  isOnboardingTaskStateChangesRequested,
  isOnboardingTaskStateCompleted,
  isOnboardingTaskStatePendingApproval,
} from '../../Utils/onboardingUtils'
import {rxrOrangeColor, rxrRedColor, rxrStatusGreenColor, rxrTintColor} from '../../assets/styles/color'
import ProgressBar from '../ProgressBar'
import {makeStyles} from '@mui/styles'
import {spaceSmall} from '../../assets/styles/spacing'
import {fontSizeMedium, fontSizeMediumSmall} from '../../assets/styles/typography'
import PropTypes from 'prop-types'

export const LABEL_PLACEHOLDER_COMPLETED = 'com'
export const LABEL_PLACEHOLDER_TOTAL = 'tot'

const DEFAULT_LABEL_FORMAT = `${LABEL_PLACEHOLDER_COMPLETED}/${LABEL_PLACEHOLDER_TOTAL}`

function OnboardingTasksProgressBar(props) {
  const classes = useStyles()
  const {occupancy} = props
  const [labelStr, setLabelStr] = useState('')

  const hasOnboardingTasks =
    occupancy.onboardingTasks &&
    Array.isArray(occupancy.onboardingTasks) &&
    occupancy.onboardingTasks.filter(
      task => task.importance === ONBOARDING_IMPORTANCE_CRITICAL || task.importance === ONBOARDING_IMPORTANCE_REQUIRED,
    ).length > 0
  const onboardingTasks = hasOnboardingTasks
    ? occupancy.onboardingTasks.filter(
        task => task.importance === ONBOARDING_IMPORTANCE_CRITICAL || task.importance === ONBOARDING_IMPORTANCE_REQUIRED,
      )
    : []
  const totalOnboardingTasks = hasOnboardingTasks ? onboardingTasks.length : 0
  const completedOnboardingTasks = hasOnboardingTasks
    ? onboardingTasks.reduce((accum, currVal) => {
        if (isOnboardingTaskStateCompleted(currVal.state)) {
          accum++
        }
        return accum
      }, 0)
    : 0
  const numTasksPendingApproval = hasOnboardingTasks
    ? onboardingTasks.reduce((accum, currVal) => {
        if (isOnboardingTaskStatePendingApproval(currVal.state)) {
          accum++
        }
        return accum
      }, 0)
    : 0
  const numTasksChangesRequested = hasOnboardingTasks
    ? onboardingTasks.reduce((accum, currVal) => {
        if (isOnboardingTaskStateChangesRequested(currVal.state)) {
          accum++
        }
        return accum
      }, 0)
    : 0

  useEffect(() => {
    const format = props.labelFormat || DEFAULT_LABEL_FORMAT
    setLabelStr(
      format
        .replace(LABEL_PLACEHOLDER_COMPLETED, '' + completedOnboardingTasks)
        .replace(LABEL_PLACEHOLDER_TOTAL, '' + totalOnboardingTasks),
    )
  }, [props.labelFormat, totalOnboardingTasks, completedOnboardingTasks])

  const completedAllTasks = hasOnboardingTasks && completedOnboardingTasks === totalOnboardingTasks
  const dynamicColor =
    numTasksPendingApproval > 0
      ? rxrOrangeColor
      : numTasksChangesRequested > 0
      ? rxrRedColor
      : completedAllTasks
      ? rxrStatusGreenColor
      : rxrTintColor

  return (
    <div>
      {totalOnboardingTasks > 0 ? (
        <div className={classes.progressContainer}>
          <div className={classes.progressBarContainer} style={props.height ? {height: props.height} : undefined}>
            <ProgressBar
              color={dynamicColor}
              progress={hasOnboardingTasks ? completedOnboardingTasks / totalOnboardingTasks : 0}
              height={props.height}
            />
          </div>
          <div className={classes.onboardingTasksCopyContainer}>{labelStr}</div>
        </div>
      ) : (
        <div>{'Manual onboarding'}</div>
      )}
    </div>
  )
}

OnboardingTasksProgressBar.propTypes = {
  occupancy: PropTypes.object.isRequired,
  height: PropTypes.any,
  labelFormat: PropTypes.string, // use placeholders "com" and "tot". Default is "com/tot"
}

const useStyles = makeStyles(theme => {
  return {
    progressContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    progressBarContainer: {
      width: '100%',
      height: '10px',
    },
    onboardingTasksCopyContainer: {
      marginRight: spaceSmall,
      marginLeft: spaceSmall,
      fontSize: fontSizeMediumSmall,
      whiteSpace: 'nowrap',
    },
  }
})

export default OnboardingTasksProgressBar
